import type { CreateNPIListRequest, DownloadNPIsRequest, RemoveNPIListRequest } from '../../lib/api/npiList';
import { useDownloadNPIsListMutation, usePublishNPIsListMutation, useRemoveNPIListMutation } from '../api/useNpiList';

export const useWorkspaceNpiApi = () => {
  const removeNpiListMutation = useRemoveNPIListMutation();
  const publishNpiListMutation = usePublishNPIsListMutation();
  const downloadNpiListMutation = useDownloadNPIsListMutation();

  const downloadNPIs = async (downloadOptions: DownloadNPIsRequest) => {
    const { fileFormat, lookerFilters, workspaceID } = downloadOptions;

    if (fileFormat && lookerFilters) {
      try {
        const data = await downloadNpiListMutation.mutateAsync({
          fileFormat,
          lookerFilters,
          workspaceID,
        });
        return { data };
      } catch (error) {
        console.error('Error downloading NPIs:', error);
        return { error: 'Error Downloading' };
      }
    } else {
      console.error('Missing parameters for downloading NPIs');
      return { error: 'Missing parameters for downloading NPIs' };
    }
  };

  const publishNPIList = async (createOptions: CreateNPIListRequest) => {
    try {
      return await publishNpiListMutation.mutateAsync(createOptions);
    } catch (error) {
      console.error('Error Publishing List NPIs:', error);
      return null;
    }
  };

  const removeNPIList = async (removeOption: RemoveNPIListRequest) => {
    try {
      const data = await removeNpiListMutation.mutateAsync(removeOption);
      return { data };
    } catch (error) {
      console.error('Error Removing List NPIs:', error);
      return { error: 'Error Removing List NPIs:' };
    }
  };

  return {
    downloadNPIs,
    removeNPIList,
    publishNPIList,

    removeNPIListResponse: removeNpiListMutation,
    downloadNPIsResponse: downloadNpiListMutation,
    publishNPIsResponse: publishNpiListMutation,

    isRemoveNPIListSuccessful: removeNpiListMutation.isSuccess,
    isRemoveNPIListLoading: removeNpiListMutation.isPending,
    isRemoveNPIListError: removeNpiListMutation.isError,

    isDownloadNPIsSuccessful: downloadNpiListMutation.isSuccess,
    isDownloadNPIsLoading: downloadNpiListMutation.isPending,
    isDownloadNPIsError: downloadNpiListMutation.isError,

    isPublishNPIsSuccessful: publishNpiListMutation.isSuccess,
    isPublishNPIsLoading: publishNpiListMutation.isPending,
    isPublishNPIsError: publishNpiListMutation.isError,
  };
};
